"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mountIsland_1 = require("../mountIsland");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var Lang_js_1 = require("../Lang.js");
var NAVY = '#1c1c3c';
var STATUS_CONFIG = {
    active: { label: 'Active', color: '#1a6e1e', bg: 'rgba(25,148,32,0.10)' },
    past_due: { label: 'Past Due', color: '#92400e', bg: 'rgba(245,158,11,0.12)' },
    canceled: { label: 'Canceled', color: '#9e3a3a', bg: 'rgba(211,47,47,0.09)' },
    trialing: { label: 'Trial', color: '#0369a1', bg: 'rgba(3,105,161,0.09)' },
    incomplete: { label: 'Incomplete', color: '#555', bg: 'rgba(0,0,0,0.06)' },
};
function formatDate(d) {
    if (!d)
        return '—';
    var _a = d.split('-').map(Number), y = _a[0], m = _a[1], day = _a[2];
    return new Date(y, m - 1, day).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
var StatusBadge = function (_a) {
    var _b;
    var status = _a.status;
    var cfg = (_b = STATUS_CONFIG[status]) !== null && _b !== void 0 ? _b : STATUS_CONFIG.incomplete;
    return (react_1.default.createElement(Box_1.default, { sx: {
            display: 'inline-flex', alignItems: 'center', gap: '5px',
            px: '10px', py: '3px', borderRadius: '12px',
            backgroundColor: cfg.bg, color: cfg.color,
            fontSize: '12px', fontWeight: 700, whiteSpace: 'nowrap',
        } },
        react_1.default.createElement(Box_1.default, { sx: { width: '6px', height: '6px', borderRadius: '50%', backgroundColor: cfg.color, flexShrink: 0 } }),
        cfg.label));
};
var StatCard = function (_a) {
    var label = _a.label, value = _a.value, sub = _a.sub;
    return (react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
            p: '18px 22px', borderRadius: 2, backgroundColor: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.07)', flex: 1,
        } },
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 0.5 } }, label),
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '28px', fontWeight: 700, color: NAVY, lineHeight: 1 } }, value),
        sub && react_1.default.createElement(Typography_1.default, { sx: { mt: 0.5, fontSize: '12px', color: '#aaa' } }, sub)));
};
var AdminSubscriberList = function () {
    var bootstrapEl = document.getElementById('msia-admin-billing-bootstrap');
    var subscribers = [];
    var stats = { total_active: 0, total_past_due: 0, monthly_revenue: 0 };
    try {
        var d = bootstrapEl ? JSON.parse(bootstrapEl.textContent || '{}') : {};
        subscribers = d.subscribers || [];
        stats = d.stats || stats;
    }
    catch (e) {
        console.warn('AdminSubscriberList: parse error', e);
    }
    var _a = (0, react_1.useState)(''), search = _a[0], setSearch = _a[1];
    var _b = (0, react_1.useState)('all'), statusFilter = _b[0], setStatusFilter = _b[1];
    var filtered = subscribers.filter(function (s) {
        var q = search.toLowerCase();
        var matchesSearch = !q
            || s.name.toLowerCase().includes(q)
            || s.email.toLowerCase().includes(q)
            || s.member_id.includes(q)
            || s.stripe_sub_id.includes(q);
        var matchesStatus = statusFilter === 'all' || s.status === statusFilter;
        return matchesSearch && matchesStatus;
    });
    var filterOptions = [
        { value: 'all', label: 'All' },
        { value: 'active', label: 'Active' },
        { value: 'past_due', label: 'Past Due' },
        { value: 'trialing', label: 'Trial' },
        { value: 'canceled', label: 'Canceled' },
    ];
    return (react_1.default.createElement(Box_1.default, { sx: { p: 2, maxWidth: '1400px', mx: 'auto', backgroundColor: '#f5f6f8', minHeight: '80vh' } },
        react_1.default.createElement(Box_1.default, { sx: { mb: 3, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 } },
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Typography_1.default, { component: "a", href: "/app/admin", sx: { display: 'block', mb: 1.5, fontSize: '13px', fontWeight: 600, color: NAVY, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } } },
                    "\u2190 ",
                    (0, Lang_js_1.__)('Admin Dashboard')),
                react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h1", sx: { mt: 0.5, fontSize: '24px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('TWI Subscribers')))),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' } },
            react_1.default.createElement(StatCard, { label: "Active Subscribers", value: stats.total_active, sub: "TWI & Seminar Leader" }),
            react_1.default.createElement(StatCard, { label: "Past Due", value: stats.total_past_due, sub: "Needs attention" }),
            react_1.default.createElement(StatCard, { label: "Monthly Revenue", value: "$".concat(stats.monthly_revenue.toFixed(2)), sub: "Active + past due" })),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                p: '14px 18px', mb: 2, borderRadius: 2,
                backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.07)',
                display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap',
            } },
            react_1.default.createElement(TextField_1.default, { placeholder: (0, Lang_js_1.__)('Search by name, email, member ID, or Stripe sub ID…'), value: search, onChange: function (e) { return setSearch(e.target.value); }, size: "small", sx: { flex: 1, minWidth: '240px' }, InputProps: {
                    startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '16px', color: '#aaa' } }, "\u2315"))),
                } }),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 1, flexWrap: 'wrap' } }, filterOptions.map(function (opt) { return (react_1.default.createElement(Box_1.default, { key: opt.value, onClick: function () { return setStatusFilter(opt.value); }, sx: {
                    px: '14px', py: '5px', borderRadius: '20px', cursor: 'pointer',
                    fontSize: '13px', fontWeight: 600,
                    backgroundColor: statusFilter === opt.value ? NAVY : 'transparent',
                    color: statusFilter === opt.value ? '#fff' : '#555',
                    border: "1px solid ".concat(statusFilter === opt.value ? NAVY : '#ddd'),
                    transition: 'all 0.15s ease',
                    '&:hover': { borderColor: NAVY, color: statusFilter === opt.value ? '#fff' : NAVY },
                } }, opt.label)); })),
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#888', ml: 'auto', whiteSpace: 'nowrap' } },
                filtered.length,
                " ",
                filtered.length === 1 ? (0, Lang_js_1.__)('result') : (0, Lang_js_1.__)('results'))),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                borderRadius: 2, backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.07)',
                overflow: 'hidden',
            } },
            react_1.default.createElement(Box_1.default, { sx: {
                    display: 'grid',
                    gridTemplateColumns: '2fr 2fr 1fr 2fr 1fr 1.2fr 1fr 100px',
                    px: '18px', py: '10px',
                    backgroundColor: '#f8f9fa',
                    borderBottom: '1px solid #e8e8e8',
                } }, ['Name / Email', 'Member ID', 'Plan', 'Status', 'Amount', 'Next Billing', 'Since', 'Actions'].map(function (h) { return (react_1.default.createElement(Typography_1.default, { key: h, sx: { fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px' } }, h)); })),
            filtered.length === 0 ? (react_1.default.createElement(Box_1.default, { sx: { p: '32px', textAlign: 'center' } },
                react_1.default.createElement(Typography_1.default, { sx: { color: '#aaa', fontSize: '14px' } }, (0, Lang_js_1.__)('No subscribers match your filters.')))) : (filtered.map(function (s, idx) { return (react_1.default.createElement(Box_1.default, { key: s.id, sx: {
                    display: 'grid',
                    gridTemplateColumns: '2fr 2fr 1fr 2fr 1fr 1.2fr 1fr 100px',
                    px: '18px', py: '14px',
                    borderBottom: idx < filtered.length - 1 ? '1px solid #f0f0f0' : 'none',
                    alignItems: 'center',
                    '&:hover': { backgroundColor: '#fafbfc' },
                } },
                react_1.default.createElement(Box_1.default, null,
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', fontWeight: 600, color: NAVY } }, s.name),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#888', mt: '2px' } }, s.email)),
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555', fontFamily: 'monospace' } }, s.member_id),
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#333', lineHeight: 1.4 } }, s.plan),
                react_1.default.createElement(Box_1.default, null,
                    react_1.default.createElement(StatusBadge, { status: s.status }),
                    s.status === 'past_due' && (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '11px', color: '#92400e', mt: '3px' } }, (0, Lang_js_1.__)('Payment retry in progress')))),
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', fontWeight: 600, color: '#333' } },
                    "$",
                    s.amount.toFixed(2),
                    "/mo"),
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555' } }, s.next_billing ? formatDate(s.next_billing) : '—'),
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#888' } }, formatDate(s.start_date)),
                react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 1 } },
                    react_1.default.createElement(Box_1.default, { component: "a", href: "/app/admin/twi/subscribers/".concat(s.id), sx: {
                            px: '10px', py: '5px', borderRadius: '4px',
                            backgroundColor: NAVY, color: '#fff',
                            fontSize: '12px', fontWeight: 600, textDecoration: 'none',
                            whiteSpace: 'nowrap',
                            '&:hover': { backgroundColor: '#2a2a4c', textDecoration: 'none', color: '#fff' },
                        } }, (0, Lang_js_1.__)('View'))))); })))));
};
var adminBillingListEl = document.getElementById('msia-admin-billing-container');
if (adminBillingListEl) {
    (0, mountIsland_1.mountIsland)(adminBillingListEl, react_1.default.createElement(AdminSubscriberList, null));
}
exports.default = AdminSubscriberList;
